<template>
  <transition name="fade">
   
    <div class="situs-warp" v-if="situs">
      <img class="situs-bg" src="../assets/image/form-bg1.png" alt="" />
      <div class="situs-form">
        <div class="situs-form-container">
          <div class="situs-form-title">站点绑定</div>
          <div>
            <img class="login-miyao" src="../assets/image/miyao.png" alt />
            <img class="situs-input" src="../assets/image/input1.png" alt="" />
            <input
              type="text"
              v-model="form.serect"
              placeholder="注册秘钥 (必填项)"
              ref="serect"
            />
          </div>
          <div>
            <img class="login-mingcheng" src="../assets/image/mingcheng.png" alt />  
            <img class="situs-input" src="../assets/image/input1.png" alt="" />
            <input
              type="text"
              v-model="form.name"
              placeholder="站点名称  (必填项)"
              ref="name"
            />
          </div>
          <div>
            <img class="login-zuoji" src="../assets/image/zuoji.png" alt />  
            <img class="situs-input" src="../assets/image/input1.png" alt="" />
            <input
              type="text"
              v-model="form.phone"
              placeholder="座机号码  (选填项)"
              ref="phone"
              @keyup.enter="confirm" 
            />
          </div>
        </div>
        <div class="situs-form-foot">
          <!-- <img class="situs-button" src="../assets/image/button1.png" alt="" /> -->
          <div class="situs-confirm" @click="confirm">绑 定</div>
          
        </div>
        <div v-if="errormsg != null" class="errormsg">{{errormsg}}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { postRequest,getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      situs: true,
      form: {},
      msg: {},
      errormsg:null,
      mac:null,
      ip:null,
      resources:null,
    };
  },
  created() {
    
    if (this.$route.query.msg) {
      this.msg = JSON.parse(this.$route.query.msg);
      this.mac = this.msg.situs.mac;
      this.ip = this.msg.situs.ip;
      this.resources= this.msg.situs.resources;
      if(this.resources == 1){
        getRequest("http://127.0.0.1:9009/readConfig").then((res) => {
          this.$parent.hotelName = "秒宿PMS";
          if(res.hotelname != null || res.hotelname != '' ){
             this.$parent.hotelName = res.hotelname;
          }
          if(res.company != null || res.company != '' ){
             this.$parent.company = res.company;
          }
          this.$parent.jdlogo = res.logo;
          this.$parent.mobile = res.mobile;
          this.$store.state.psmlogo =  res.pmslogo;
        });
      }
    }
    if (this.$route.query.errorcode) {
      this.errormsg = this.$route.query.errorcode;
      this.mac = this.$route.query.mac;
      this.ip = this.$route.query.ip;
      this.$mymessage({
          content: this.$route.query.errorcode,
          type: "error",
          time: 3000,
          hasClose: true,
        });
    }
  },
  methods: {
    confirm() {
      
      if (!this.form.serect) {
        this.$mymessage({
          content: "站点密钥不能为空",
          type: "error",
          time: 3000,
          hasClose: true,
        });
        this.$refs.serect.focus();
        return;
      }
      if (!this.form.name) {
        this.$mymessage({
          content: "站点名称不能为空",
          type: "error",
          time: 3000,
          hasClose: true,
        });
        this.$refs.name.focus();
        return;
      }
      // if (!this.form.phone) {
      //   this.$mymessage({
      //     content: "座机号码不能为空",
      //     type: "error",
      //     time: 3000,
      //     hasClose: true,
      //   });
      //   this.$refs.phone.focus();
      //   return;
      // }
    
      let serectReg = /^\w|-{0,50}$/;
      if (serectReg.test(this.form.serect)) {
        
      } else {
        if (this.form.serect.length > 50) {
          this.$mymessage({
            content: "站点密钥不允许超过50位",
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
        if (/[\u4e00-\u9fa5]+/.test(this.form.serect)) {
          this.$mymessage({
            content: "站点密钥不支持中文",
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
        this.$refs.serect.focus();
        return;
      }

      if (this.form.name.length > 20) {
        this.$mymessage({
          content: "站点名称不允许超过20位",
          type: "error",
          time: 3000,
          hasClose: true,
        });
        this.$refs.name.focus();
        return;
      }
    if (this.form.phone) {
      let phoneReg = /^[0][1-9]{2,3}-[0-9]{5,10}$/;
      if (phoneReg.test(this.form.phone)) {
        
      } else {
        this.$mymessage({
          content: "座机号码格式错误",
          type: "error",
          time: 3000,
          hasClose: true,
        });
        this.$refs.phone.focus();
        return;
      }
    }
      
      let loadingInstance = this.$loading({
        text: "站点绑定中",
      });
      if(this.mac == null || this.mac == "" || this.mac == "null"){
        this.$mymessage({
            content: "加载出错,请关闭后重新打开软件",
            type: "error",
            time: 2000,
            hasClose: true,
          });
        return;
      }
      postRequest("/tSysSitus/register", {
        ccode: this.form.serect,
        cdesc: this.form.name,
        ctel: this.form.phone,
        mac:  this.mac,
        ip: this.ip,
      }).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.$router.replace("/login?situs=" + res.data.situs.ccode+"&logo="+res.data.hotel.logo+"&name="+res.data.hotel.cname);
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 2000,
            hasClose: true,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.login-miyao{
    position: absolute;
    left: 5%;
    width:1.8em;
    z-index: 9;
    top: 18%;
}
.login-mingcheng{
    position: absolute;
    left: 5%;
    width:1.8em;
    z-index: 9;
    top: 18%;
}
.login-zuoji{
    position: absolute;
    left: 5%;
    width:1.8em;
    z-index: 9;
    top: 18%;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
  position: absolute;
  top: 0;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
}
.situs-warp {
  width: 100%;
  height: 100%;
}
.situs-bg {
  width: 100%;
  height: 100%;
  background: #e7f0ff;
  opacity: .5;
}
.situs-form {
  position: absolute;
  top: 7%;
  left: 8%;
  width: 84%;
  height: 86%;
}
.situs-form-title {
  color: #2562a5;
  font-size: 1.75em;
  display: flex;
  align-items: center;
}
.situs-form-container {
  height: 72%;
  margin: 0 10%;
  display: flex;
  flex-direction: column;
}
.situs-form-container div {
  flex: 1;
  position: relative;
}
.situs-form-container input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 70% !important;
  border: none;
  padding-left: 20%;
 
  outline: none;
  font-size: 16px;
  color: #6d798e;
}
.situs-input {
  width: 100%;
  height: 70%;
  color: #6d798e;
  font-size: 1.3em;
}
.situs-form-foot {
  height: 28%;
  position: relative;
  top: -3%;
}
.situs-button {
  width: 100%;
  height: 100%;
}


.situs-confirm {
    position: absolute;
    top: 28%;
    left: 9.5%;
    width: 81%;
    font-size: 1.7em;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: #1471fe !important;
    color: #fff !important;
    height: 45%;
    border-radius: .2em;
}
.situs-confirm:hover {
  transform: scale(1.1);
}
.errormsg{
  text-align: center;margin-top: -30px;color:red;font-weight:bold;font-size:16px;
}
</style>